import { render, staticRenderFns } from "./AfterWithdrawModal.vue?vue&type=template&id=163d6aea&scoped=true&"
import script from "./AfterWithdrawModal.vue?vue&type=script&lang=js&"
export * from "./AfterWithdrawModal.vue?vue&type=script&lang=js&"
import style0 from "./AfterWithdrawModal.vue?vue&type=style&index=0&id=163d6aea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163d6aea",
  null
  
)

export default component.exports